import { InjectionToken } from '@angular/core';

/**
 * Provider that allows a consumer to explicitly provide the IFileUploadConfig.
 */
export const WITH_CREDENTIALS_CONFIG = new InjectionToken('WITH_CREDENTIALS_CONFIG');

/**
 * Interface that represents the required and optional configuration values for the module.
 */
export interface IWithCredentialsConfig {
  origins: string[];
}
